export default __webpack_public_path__ + "static-bigflip/media/letter-of-attorney.04316447.png";